import $ from 'jquery'

const moreInfo = () => {
  $('.list-box .infotext').each( function() {
    if( $(this).height() >= 40 ) {
      $(this).css('height', '16px');
      $(this).prev('.infotitle').addClass('over');
      
      $(this).prev('.infotitle').click(function() {
        $(this).toggleClass('open');
        $(this).next('.infotext').toggleClass('open');
      });
    }
  })
}
  
( () => {
  moreInfo()
})()